import { Header } from "@/components/home/Header";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Services } from "@/components/home/Services";
import { BeforeAfter } from "@/components/home/BeforeAfter";
import { Why } from "@/components/home/Why";
import { CareCalendar } from "@/components/home/CareCalendar";
import { Reviews } from "@/components/home/Reviews";
import { Area } from "@/components/home/Area";
import { Process } from "@/components/home/Process";
import { Inquiry } from "@/components/home/Inquiry";
import { Footer } from "@/components/home/Footer";

export default function Home() {
  return (
    <div className="overflow-x-clip">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <BeforeAfter />
        <Why />
        <Reviews />
        <Process />
        <CareCalendar />
        <Area />
        <Inquiry />
      </main>
      <Footer />
    </div>
  );
}
